import BaseComponent from 'scripts/BaseComponent.js';
import Accordion from 'scripts/Accordion.js';

export default class CollectionFaq extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      faqs: '.js-collectionFaqs',
      toggle: '.js-accordionItemToggle',
    };

    this.dom = {
      $component: component,
      $faqs: this.$get(this.refs.faqs),
      $firstToggle: this.$get(this.refs.toggle),
    };

    this.state = {
      accordion: null,
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    const { dom, state } = this;
    state.accordion = new Accordion(dom.$faqs);

    if (dom.$firstToggle) {
      dom.$firstToggle.click();
    }
  }
}
